import React, { useContext } from "react";
import "./navbarAndForm.scss";
import { Nav, Tab, Row, Modal } from "react-bootstrap";
import { FormTerms, FormContainer, ClaimantSelect } from "../../Components";
import { DataContext } from "../../js/App";
import Overview from "../Overview";

const NavbarAndForm = () => {
  const context = useContext(DataContext);
  const { termsAccepted, activeTab, setActiveTab, policyForm, setNavArray, navArray, endpointError, webFormData } = context;

  const pageNames =
    policyForm && Object.values(policyForm).map((page) => page.title);

  if(navArray === null){
    setNavArray(pageNames);
  }
  
  return (
    <Tab.Container
      id="left-tabs-example"
      defaultActiveKey={activeTab}
      activeKey={activeTab}
      className="fullFormContainer"
    >
      {endpointError && (
        <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
          <p>The website was not able to recover the report form. Please ask to your broker to have support.</p>
        </Modal.Body>
      </Modal.Dialog>
      )}
      {!endpointError && (<>
        <Row className="formNavbar bg-primary">
          <Nav className="navContainer" onSelect={(e) => setActiveTab(e)}>
            {policyForm === null && (
              <>
                <Nav.Item>
                  <Nav.Link eventKey="start" className="formLink">
                    Start
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    disabled={termsAccepted ? false : true}
                    eventKey="claimant"
                    className="formLink"
                  >
                    Claimant
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
            {policyForm !== null &&
              pageNames &&
              pageNames.map((pageName, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    disabled={termsAccepted ? false : true}
                    eventKey={pageName}
                    className="formLink"
                  >
                    {pageName}
                  </Nav.Link>
                </Nav.Item>
              ))}
            {policyForm !== null && (
              <Nav.Item>
                <Nav.Link eventKey="overview" className="formLink">
                  Overview
                </Nav.Link>
              </Nav.Item>)}
          </Nav>
        </Row>

        <Row>
          <Tab.Content>
            <Tab.Pane eventKey="start">
              <div className="formContainer">
                <FormTerms />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="claimant">
              <div className="formContainer">
                {webFormData && <ClaimantSelect />}
              </div>
            </Tab.Pane>
            {policyForm !== null &&
              policyForm &&
              policyForm.map((page, index) => (
                <Tab.Pane key={index} eventKey={`${page.title}`}>
                  <div className="formContainer">
                    <FormContainer index={index} fields={page.fields} />
                  </div>
                </Tab.Pane>
              ))}
              {policyForm !== null &&
              policyForm && (
                <Tab.Pane key={policyForm.length + 1} eventKey={`overview`}>
                  <div className="formContainer">
                    <Overview />
                  </div>
                </Tab.Pane>
              )}
          </Tab.Content>
        </Row>
        </>
      )}
    </Tab.Container>
  );
};

export default NavbarAndForm;
